import imgOutside from '../../assets/buildings/house/outside.png';
import { Building } from '../../interfaces/buildings';

const ksbQuickLinksConfig: Building = {
    img: imgOutside
}

export default ksbQuickLinksConfig;